import { IKitchenCalc } from '@/interfaces/IKitchenCalc';
import { createContext, useContext } from 'react';

export type IContextKitchen = {
    estimate: IKitchenCalc
    setEstimate: Function
    setStep: Function
}
export const KitchenCalcContext = createContext<Partial<IContextKitchen>>({})
export const useKitchenCalcContext = () => useContext(KitchenCalcContext)